import { OnboardingRepository } from "../repositories/OnboardingRepository";
import Category from "../entities/category";

export class GetCategories {
	constructor(private repository: OnboardingRepository) {}
	execute(params: GetCategoriesParams): Promise<Category[]> {
		return this.repository.getCategories(params.endpoint);
	}
}

export class GetCategoriesParams {
	constructor(public endpoint: string) {}
}
